export enum OpeningSystemType {
  sliding = 0,
  turning = 1,
  folding = 2,
}
